import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AdminDashboard from "@/pages/AdminDashboard";
import CandidateChat from "@/pages/CandidateChat";
import ApplyForm from "@/pages/ApplyForm";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/candidate" element={<CandidateChat />} />
          <Route path="/form" element={<ApplyForm />} />
          <Route path="/apply" element={<ApplyForm />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
